export class GroupCandidate {
  firstName: string;
  lastName: string;
  email: string;

  constructor(stats?: Partial<GroupCandidate>) {
    Object.assign(this, stats);
  }
}
